import { NumericFormat } from 'react-number-format';
import { FieldError } from 'react-hook-form';

type Props = {
  onChange: (v: string) => void;
  onBlur?: (value: string | number | null | undefined) => void;
  error?: boolean | FieldError;
  value?: string | number | null | undefined;
  disabled?: boolean;
  classNames?: string;
};
export const InputRatio = ({ onChange, onBlur, value, error, disabled, classNames = '' }: Props) => {
  return (
    <NumericFormat
      className={`form-control text-end ${error && 'is-invalid'} ${classNames}`}
      thousandSeparator={`,`}
      onValueChange={(v) => onChange(v.value)}
      allowNegative={false}
      value={value}
      disabled={disabled}
      suffix={' %'}
      maxLength={5}
      onBlur={() => {
        onBlur && onBlur(value);
      }}
      isAllowed={(values) => {
        const { floatValue } = values;
        if (floatValue == null) {
          return true;
        }
        return floatValue >= 0 && floatValue <= 100;
      }}
    />
  );
};
